<template>
    <v-alert
        class="message"
        v-model="show"
        :type="type"
        dismissible
        :key="key"
        transition="slide"
        mode="out-in"
    >
        {{ message }}
    </v-alert>
</template>

<script>
import MessageBus from '../utils/buses/MessageBus'

export default {
    data () {
        return {
            show: false,
            type: 'success',
            message: '',
            key: null,
            timeout: null
        }
    },
    created () {
        MessageBus.$on('message-sent', this.showMessage)
    },
    beforeDestroy () {
        // remove event listener to avoid memory leaks
        MessageBus.$off('message-sent', this.showMessage)
    },
    methods: {
        showMessage (message, type, key) {
            this.message = message
            this.type = type
            this.key = key
            this.show = true
            if (this.timeout) {
                clearTimeout(this.timeout)
            }
            // clear message after 8 seconds
            this.timeout = setTimeout(() => {
                this.show = false
            }, 8000)
        },
        clearMessage () {
            this.message = ''
            this.type = null
        }
    }
}
</script>

<style lang="scss" scoped>
    .message {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0;
        z-index: 1000;
    }
    .slide-leave-active,
    .slide-enter-active {
        transition: 0.3s;
    }
    .slide-enter {
        transform: translate(0, 100%);
    }
    .slide-leave-to {
        opacity: 0;
    }
</style>
